import { FC, useEffect, useState, Dispatch } from "react";
import { useTranslation } from "react-i18next";
import { Box, Dialog, DialogContent, DialogTitle, Typography, TextField, DialogActions, Button, CircularProgress, InputLabel, Alert } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { withCursorPosition } from "../../../../../../shell/components/withCursorPosition";
const TextFieldWithCursorPosition = withCursorPosition(TextField);
interface Props {
  handleUpdateMutation: (renamedFilename: string) => void;
  onClose?: () => void;
  onSetNewFilename: Dispatch<string>;
  newFilename: string;
  isSuccessUpdate: boolean;
  isLoadingUpdate: boolean;
  resetUpdate: any;
  extension: string;
  src: string;
}
export const RenameFileModal: FC<Props> = ({
  handleUpdateMutation,
  onClose,
  onSetNewFilename,
  newFilename,
  isSuccessUpdate,
  isLoadingUpdate,
  resetUpdate,
  extension,
  src
}) => {
  const {
    t
  } = useTranslation();
  const [renamedFilename, setRenamedFilename] = useState<string>(newFilename);
  useEffect(() => {
    if (!isLoadingUpdate && isSuccessUpdate) {
      resetUpdate();
      onClose();
    }
  }, [isLoadingUpdate, isSuccessUpdate]);
  const handleUpdate = () => {
    onSetNewFilename(renamedFilename);
    handleUpdateMutation(renamedFilename);
  };
  return <Dialog open={true} fullWidth maxWidth={"xs"} onClose={onClose} data-sentry-element="Dialog" data-sentry-component="RenameFileModal" data-sentry-source-file="RenameFileModal.tsx">
      <DialogTitle component="div" data-sentry-element="DialogTitle" data-sentry-source-file="RenameFileModal.tsx">
        <Box component="img" src={`${src}?height=120&width=120&fit=bounds`} width="120px" height="120px" bgcolor="grey.100" sx={{
        objectFit: "contain",
        borderRadius: "8px"
      }} mb={1.5} data-sentry-element="Box" data-sentry-source-file="RenameFileModal.tsx" />
        <Typography variant="h5" fontWeight="700" data-sentry-element="Typography" data-sentry-source-file="RenameFileModal.tsx">
          {t("media.renameFileModalTitle")}
        </Typography>
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="RenameFileModal.tsx">
        <InputLabel data-sentry-element="InputLabel" data-sentry-source-file="RenameFileModal.tsx">{t("media.renameFileModalNewNameLabel")}</InputLabel>
        <TextFieldWithCursorPosition sx={{
        mt: 1,
        width: "100%",
        "& .MuiInputBase-input": {
          overflow: "hidden",
          textOverflow: "ellipsis"
        }
      }} autoFocus onFocus={(evt: React.FocusEvent<HTMLInputElement>) => evt.target.select()} value={renamedFilename} onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
        setRenamedFilename(evt.target.value.replace(" ", "-"));
      }} onKeyPress={(event: React.KeyboardEvent<HTMLDivElement>) => event.key === "Enter" && handleUpdate()} InputProps={{
        endAdornment: <Typography variant="body2" color="text.secondary">
                .{extension}
              </Typography>
      }} data-sentry-element="TextFieldWithCursorPosition" data-sentry-source-file="RenameFileModal.tsx" />
        <Alert severity="warning" sx={{
        mt: 2.5,
        bgcolor: theme => alpha(theme.palette.warning.main, 0.1),
        color: "#643a03",
        ".MuiAlert-icon": {
          color: "#643a03"
        }
      }} data-sentry-element="Alert" data-sentry-source-file="RenameFileModal.tsx">
          {t("media.renameFileModalWarning")}
        </Alert>
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="RenameFileModal.tsx">
        <Button color="inherit" onClick={() => onClose()} data-sentry-element="Button" data-sentry-source-file="RenameFileModal.tsx">
          {t("common.cancel")}
        </Button>
        <Button variant="contained" onClick={handleUpdate} disabled={isLoadingUpdate} data-sentry-element="Button" data-sentry-source-file="RenameFileModal.tsx">
          {isLoadingUpdate ? <CircularProgress size="24px" color="inherit" /> : t("common.update")}
        </Button>
      </DialogActions>
    </Dialog>;
};
export default RenameFileModal;